import { AuthService } from "../services/auth.service";

export function initializeAppFactory(authService: AuthService): () => void {
  return () => {
    /* Commented for certain reasons might not be needed in the future. */
    //authService.refreshCsrfToken().subscribe();

    authService.init()
  }
}
